const getSoundEffectVolume = () => {
  return 0.25;
};
export default getSoundEffectVolume;
